/**
 * Customer-facing cart counts: paid products only.
 * Promotional gifts are identified by line properties or a product tag,
 * never by a $0 price (future discounts must not hide paid items).
 */
(function (window) {
  var GIFT_TAG = 'promotional-gift';

  function props(item) {
    return item && item.properties ? item.properties : {};
  }

  function isPromotionalGift(item) {
    if (!item) return false;
    var p = props(item);
    if (String(p._trio_gift || '') === '1') return true;
    if (String(p._free_gift || '').toLowerCase() === 'yes') return true;
    var tags = item.tags || item.product_tags || [];
    if (typeof tags === 'string') tags = tags.split(',');
    for (var i = 0; i < tags.length; i++) {
      if (String(tags[i] || '').trim().toLowerCase() === GIFT_TAG) return true;
    }
    return false;
  }

  function isProtection(item) {
    if (!item) return false;
    if (props(item)._shipping_protection) return true;
    return false;
  }

  function qty(item) {
    return Number(item && item.quantity) || 0;
  }

  function paidCount(cart) {
    var items = cart && cart.items;
    if (!items || !items.length) {
      return typeof cart?.item_count === 'number' ? cart.item_count : 0;
    }
    var paid = 0;
    var hasNonGift = false;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (isProtection(item)) continue;
      if (isPromotionalGift(item)) continue;
      hasNonGift = true;
      paid += qty(item);
    }
    if (!hasNonGift && items.every(isProtection)) return 0;
    return paid;
  }

  function giftCount(cart) {
    var items = cart && cart.items;
    if (!items || !items.length) return 0;
    var n = 0;
    for (var i = 0; i < items.length; i++) {
      if (isPromotionalGift(items[i])) n += qty(items[i]);
    }
    return n;
  }

  function formatSummary(paid, gifts, labels) {
    labels = labels || {};
    var products = labels.products || 'products';
    var giftWord = labels.gifts || 'gifts';
    var freeGifts = labels.freeGifts || 'free gifts';
    var items = labels.items || 'items';
    var paidN = Math.max(0, Number(paid) || 0);
    var giftN = Math.max(0, Number(gifts) || 0);
    if (giftN > 0) {
      return paidN + ' ' + products + ' + ' + giftN + ' ' + (labels.useFreeGifts === false ? giftWord : freeGifts);
    }
    return paidN + ' ' + (labels.noGiftSuffix || items);
  }

  function ritualSummary(paid, gifts, labels) {
    labels = Object.assign({}, labels, { useFreeGifts: false, gifts: (labels && labels.gifts) || 'gifts' });
    var paidN = Math.max(0, Number(paid) || 0);
    var giftN = Math.max(0, Number(gifts) || 0);
    if (giftN > 0) {
      return paidN + ' ' + (labels.products || 'products') + ' + ' + giftN + ' ' + (labels.gifts || 'gifts');
    }
    return paidN + ' ' + (labels.items || 'items');
  }

  window.ssCartCount = {
    isPromotionalGift: isPromotionalGift,
    isProtection: isProtection,
    paidCount: paidCount,
    giftCount: giftCount,
    formatSummary: formatSummary,
    ritualSummary: ritualSummary,
  };
})(window);
